<template>
  <div class="calendar-year-month">
    <div
      class="calendar-year-month-title"
      :class="{
        'current': isCurrMonth
      }"
    >{{ title }}</div>
    <div class="calendar-year-month-header">
      <div
        v-for="h in headers"
        :key="h"
        class="calendar-year-month-th"
      >{{ h }}</div>
    </div>
    <div class="calendar-year-month-panel">
      <div
        v-for="(d, index) in monthData"
        :key="index"
        class="calendar-year-month-day"
        :class="{
          'disabled': d.cMonth !== month + 1,
          'active': d.cMonth === month + 1 && d.isToday,
          'has-task': taskCount[d.format] && taskCount[d.format].length,
          'is-active': !!searchValue.length && d.cMonth === month + 1
        }"
      >
        <el-popover
          v-if="taskCount[d.format] && taskCount[d.format].length"
          v-model="d.triggered"
          placement="right"
          trigger="click"
        >
          <span slot="reference">{{ d.cDay }}</span>
          <task-list
            v-if="d.triggered"
            :tasks="taskCount[d.format]"
            :date="d"
            @close="d.triggered=false"
          />
        </el-popover>
        <span v-else>{{ d.cDay }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import calendarUtil from '@/utils/calendar'
import TaskList from '../tasks/taskList'
const cnMonth = calendarUtil.getCnMonth()
export default {
  name: 'CalendarYearMonth',
  components: {
    TaskList
  },
  props: {
    curDate: String,
    year: Number,
    month: Number,
    taskCount: Object
  },
  mounted () {
  },
  data () {
    return {
      title: cnMonth[this.month],
      headers: ['一', '二', '三', '四', '五', '六', '日'],
      monthData: this.initMonthData(),
      curDay: moment(this.curDate).get('date')
    }
  },
  watch: {
    year () {
      this.monthData = this.initMonthData()
    }
  },
  computed: {
    isCurrMonth () {
      return moment().isSame(moment([this.year, (this.month)]), 'month')
    },
    searchValue () {
      return this.$store.state.calendar.searchValue
    }
  },
  methods: {
    initMonthData () {
      const thisMonth = `${this.year}-${this.month + 1}`
      return calendarUtil.createMonthCalendar(thisMonth)
    }
  }
}
</script>
<style lang="stylus">
.calendar-year-month
  padding 15px 0 20px
  &-header
    padding 0 13px 0 8px
    display flex
    flex-direction row
    justify-content space-between
    align-items flex-start
    flex-wrap nowrap
    color #bfbfbf
  &-title
    margin 0 0 7px 7px
    font-size 18px
    color #4a4a4a
    &.current
      color #ed6c00
  &-panel
    padding 0 5px 0 3px
    display flex
    flex-wrap wrap
    font-size 10px
  &-day
    position relative
    flex 0 0 14%
    margin-top 4px
    line-height 24px
    height 24px
    text-align center
    &.disabled
      color #bfbfbf
      cursor default
    &.active
      background-color #ed6c00
      border-radius 50%
      color #fff
      &.has-task:after
        background-color #fff
    &.has-task
      cursor pointer
      &:after
        background-color #c3c3c3
        content ''
        position absolute
        bottom 1px
        left 50%
        transform translateX(-50%)
        width 4px
        height 4px
        border-radius 50%
    &.is-active
      &:after
        background-color #ed6c00
</style>
